module.exports = __webpack_public_path__ + "img/no-admins.10fcd9c0.webp";